<div class="text-right">
  <button type="button" (click)="openmodal()" class="text-link text-sm bg-transparent border-0"><i class="fa fa-cog"></i><span class="ml-1">Settings</span></button>
</div>
<form #newuserprofile="ngForm" (ngSubmit)="createupdateuserprofile()" class="text-center mt-3 mb-0">
  <div class="d-flex align-items-center justify-content-center gap-1.5 flex-wrap">
    <img #logoimg src="{{userimage}}" alt="Profile picture of {{userprofile.name}}" class="user-img bg-gray-100 rounded-circle shadow-sm-darker object-cover object-center">
    <button (click)="logo.click()" type="button" id="courseHeaderImgLabel" class="btn m-0"><i class="fa fa-plus"></i> Change picture</button>
    <input #logo (change)="handleLogoFileChange($event.target.files)" type="file" accept="image/*" name="logo" aria-labelledby="courseHeaderImgLabel" id="courseHeaderImg" class="sr-only">
    <!-- <span class="text-sm">Profile Image ({{settings.userImageWidth}} x {{settings.userImageHeight}} pixels required)</span> -->
  </div>
  <div class="d-flex flex-column mt-5">
    <div class="fieldset fieldset--lg">
      <label class="legend" for="schoolname">Name</label>
      <input type="text" [(ngModel)]="userprofile.name" #name name="name" masmength="200" required class="text-field" id="schoolname" placeholder="Jane Doe">
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="email">Email address</label>
      <input type="email" id="email" name="email" class="text-field" placeholder="jesse@example.com" #email [(ngModel)]="userprofile.email" readonly>
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="phoneno">Phone Number</label>
      <input type="text" id="phoneno" name="phoneno" class="text-field" placeholder="2587456000" #phoneno [(ngModel)]="userprofile.phoneno">
    </div>
    <div class="fieldset fieldset--lg flex-sm-row mb-0">
      <div class="fieldset fieldset--lg flex-row align-items-center">
        <label class="mb-0 text-sm" for="showEmail">Show Email On Profile</label>
        <input type="checkbox" [(ngModel)]="userprofile.showEmail" #showEmail name="showEmail" class="mx-2" id="showEmail"
          [checked]="userprofile.id==0">
      </div>
      <div class="fieldset fieldset--lg flex-row align-items-center justify-content-sm-end">
        <label class="mb-0 text-sm" for="showPhone">Show Phone No On Profile</label>
        <input class="mx-2" type="checkbox" [(ngModel)]="userprofile.showPhone" #showPhone name="showPhone" id="showPhone"
          [checked]="userprofile.id==0">
      </div>  
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="website">Website Url</label>
      <input type="text" [(ngModel)]="userprofile.website" #website name="website" class="text-field" id="website"
        placeholder="http://websiteurl.com">
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="reqEnroll">Twitter Profile URL</label>
      <input type="text" class="text-field" [(ngModel)]="userprofile.twitter" #twitter name="twitter" id="reqEnroll" />
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="facebook">Facebook Account URL</label>
      <input type="text" class="text-field" [(ngModel)]="userprofile.facebook" #facebook name="facebook" id="facebook" />
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="linkedin">LinkedIn Profile URL</label>
      <input type="text" class="text-field" [(ngModel)]="userprofile.linkedin" #linkedin name="linkedin" id="linkedin" />
    </div>
  </div>
  <div class="fieldset fieldset--note">
    <label class="legend">About Me</label>
    <quill-editor [(ngModel)]="userprofile.safeBio" #safeBio name="safeBio"></quill-editor>
  </div>
  <div class="d-flex justify-content-center flex-wrap gap-1.5">
    <button type="submit" class="btn m-0">Update profile</button>
    <button class="btn btn--warning m-0" routerLink="/user/userprofile" [queryParams]="{userprofileID: userprofile.id}">Cancel</button>  
  </div>
</form>

<div class="modal fade" #timezoneselectorModal tabindex="-1" role="dialog" aria-labelledby="timezoneselector"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="timezoneselector">Select Timezone</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #settingsform="ngForm" name="settingsform" id="settingsform" class="text-sm"
        (ngSubmit)="savetimezone()" action="#" method="POST">
        <p class="text-center">Current Time: {{time}}<br>Current Timezone: {{timezonename}}</p>
        <div class="modal-body">
          <ng-moment-timezone-picker required [(ngModel)]="timeZoneInfo" #timeZoneName name="timeZoneName" customPlaceholderText="Select Timezone">
          </ng-moment-timezone-picker>
        </div>
        <div class="modal-footer justify-content-center gap-1.5">
          <button type="submit" class="btn m-0">Save</button>
          <button type="button" class="btn btn--warning m-0" data-dismiss="modal" aria-label="Cancel">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>
